import { EnvelopeAllovedActions, Instance } from '@const/consts';
import { IEnvelope } from '@store/modules/envelopes/types';
import { ICurrentUser, IUpdateProfile } from '@store/modules/user/types';

export enum MassSigningType {
  GRAPHICAL = 'GRAPHICAL',
  ELECTRONIC = 'ELECTRONIC',
}

export enum SigningFlowStage {
  REVIEW = 'REVIEW',
  GRAPHICAL_DRAW = 'GRAPHICAL_DRAW',
  GRAPHICAL_MARKS = 'GRAPHICAL_MARKS',
  GRAPHICAL_RESULTS = 'GRAPHICAL_RESULTS',
  VN_FPT = 'VN_FPT',
  RU_CERTIFICATE = 'RU_CERTIFICATE',
  RU_POWER = 'RU_POWER',
  RU_RESULTS = 'RU_RESULTS',
}

export const getNextSigningFlowStage = (
  instance: Instance,
  signingType: MassSigningType
): SigningFlowStage => {
  if (signingType === MassSigningType.GRAPHICAL) {
    return SigningFlowStage.GRAPHICAL_DRAW;
  }

  if (instance === Instance.VN) return SigningFlowStage.VN_FPT;
  if (instance === Instance.RU) return SigningFlowStage.RU_CERTIFICATE;

  return SigningFlowStage.REVIEW;
};

export const getMassSigningType = (
  isAllowElectronicSignature: boolean
): MassSigningType => isAllowElectronicSignature
  ? MassSigningType.GRAPHICAL
  : MassSigningType.ELECTRONIC;

export const createProfileSignatureUpdate = (
  profile: ICurrentUser,
  signature: string
): IUpdateProfile => {
  const {
    boxOguid,
    email,
    isPhoneConfirmed,
    oguid,
    phone,
    ...profileFields
  } = profile;

  return {
    ...profileFields,
    electronicSignatureImage: signature,
    isElectronicSignatureImageDeleted: false,
    password: null,
  };
};

export const shouldUpdateProfileSignature = (
  profileSignature: string | null,
  signature: string | null,
  isProfileSignatureSelected: boolean
): boolean => Boolean(
  signature &&
  !isProfileSignatureSelected &&
  signature !== profileSignature
);

export const getMassActionRowKey = (
  envelope: Pick<IEnvelope, 'box' | 'oguid' | 'direction' | 'currentUserTaskOguid'>
): string =>
  `${envelope.box.oguid}:${envelope.oguid}:${envelope.direction ?? ''}:${envelope.currentUserTaskOguid ?? ''}`;

export const getMassActionOperationKey = (
  action: EnvelopeAllovedActions,
  envelope: Pick<IEnvelope, 'currentUserTaskOguid' | 'oguid'>
): string | null => action === EnvelopeAllovedActions.STOP_PROCESS
  ? `envelope:${envelope.oguid}`
  : envelope.currentUserTaskOguid
    ? `task:${envelope.currentUserTaskOguid}`
    : null;
